/* Venerabull - the two app-shaped surfaces.

   The category page is real HTML and arrives with the document. These two are
   not: Explore all is a filter engine, and a product page is a configurator.
   Both are drawn here, from assets/vb-catalogue.json - the same file the
   category page was generated from, so one shelf feeds four surfaces and a
   price on one page cannot disagree with a price on another.

   Routing is by query string, on the category's own page:

     /pages/saunas              the category page          (server rendered)
     /pages/saunas?view=all     everything, with filters   (here)
     /pages/saunas?p=<id>       one piece                  (here)
     /search?q=...              results                    (here)

   Liquid cannot read a query string, which is why the switch happens on this
   side. History is real: back and forward work and every URL is shareable.

   No framework, no build step, and if it never runs the category page is
   still there underneath. */
(function () {
  'use strict';

  var CAT_MOUNT = document.getElementById('vsh');
  var SR_MOUNT  = document.getElementById('vsr');
  var MOUNT     = CAT_MOUNT || SR_MOUNT;
  if (!MOUNT) { return; }

  var PAGE   = document.getElementById('vcp');
  var PAGE_TITLE = document.title;   /* the category page's own title, as the server gave it */
  var SRC    = MOUNT.getAttribute('data-src');
  var BASE   = SRC ? SRC.split('vb-catalogue.json')[0] : '';
  var CAT_ID = MOUNT.getAttribute('data-cat') || '';
  var DATA   = null;
  var BYCAT  = {};
  var BYID   = {};

  function svgLine(d) {
    return '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" ' +
           'stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' +
           '<path d="' + d + '"/></svg>';
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function money(n) {
    return '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function asset(name) { return BASE + name; }
  function qs() {
    var o = {}, s = location.search.replace(/^\?/, '');
    if (!s) { return o; }
    s.split('&').forEach(function (kv) {
      var i = kv.indexOf('=');
      var k = decodeURIComponent(i < 0 ? kv : kv.slice(0, i)).replace(/\+/g, ' ');
      var v = i < 0 ? '' : decodeURIComponent(kv.slice(i + 1).replace(/\+/g, ' '));
      o[k] = v;
    });
    return o;
  }
  /* stars(), eta() and STOCK used to live here. They rendered a star average,
     a dated delivery promise and a stock state, none of which were true, and
     they are deleted rather than left unused so that nobody wires them back up
     by finding them lying around. The catalogue still CARRIES r, rv, st, lt and
     d on every model; regenerating it without them is a separate job, and until
     then the rule is that nothing in this file may read those five fields. */

  function load() {
    if (DATA) { return Promise.resolve(DATA); }
    return fetch(SRC, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        DATA = j;
        j.cats.forEach(function (c) {
          BYCAT[c.id] = c;
          c.items.forEach(function (it) { it.cat = c.id; BYID[it.id] = it; });
        });
        return j;
      });
  }

  /* A control cannot live inside the link — a button nested in an anchor is
     invalid and the parser lifts it out. So the card is a wrapper holding the
     link and the two controls that sit over it. */
  var K = window.VBKeep || null;

  function markBtn(it) {
    if (!K) { return ''; }
    var on = K.isSaved(it.id);
    return '<button type="button" class="vs-mark' + (on ? ' is-on' : '') + '" data-vs-save="' + esc(it.id) +
      '" aria-pressed="' + (on ? 'true' : 'false') + '" title="' + (on ? 'Saved' : 'Save this') +
      '" aria-label="' + (on ? 'Remove ' : 'Save ') + esc(it.n) + '">' +
      '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true">' +
      '<path d="M12 20.5 4.2 12.9a4.6 4.6 0 1 1 6.5-6.5l1.3 1.3 1.3-1.3a4.6 4.6 0 1 1 6.5 6.5Z"/></svg></button>';
  }
  function cmpBtn(it) {
    if (!K) { return ''; }
    var on = K.inCmp(it.id);
    return '<label class="vs-cmp' + (on ? ' is-on' : '') + '">' +
      '<input type="checkbox" data-vs-cmp="' + esc(it.id) + '"' + (on ? ' checked' : '') + '>' +
      '<span>Compare</span></label>';
  }

  /* ══════════════════════════════════════════ what a card is allowed to say ══
     It used to carry a star rating, a review count, a stock state and a
     delivery level. All four were invented — 765 ratings, 263,468 reviews, on a
     company that has never sold anything to anybody — and all four are on the
     supplier ledger's own never-claim list.

     What replaces them is the only thing on this page that is BOTH true and
     worth knowing: the model's own specification line, and, once a visitor has
     told us their room, whether it clears it. A verdict against a doorway is
     worth more than a star average anyway; it is about them rather than about
     strangers. Nasser's call, 11 Sep. */
  function cardVerdict(it) {
    if (!K || !K.room) { return ''; }
    var r = null;
    try { r = K.room(); } catch (e) { r = null; }
    if (!r) { return ''; }
    var rows = fitRows(it, r);
    /* A supply given where the engine has nothing to answer from is unresolved,
       as the product page says (pdRows): a power figure the catalogue says is
       not confirmed (tbc; 1 Nov 2026, his direction on the sauna aisle), or a
       hot tub's Service line, which the engine does not read. Silence would let
       a doorway that clears stand as "Fits" beside an open electrical question.
       The engine is unchanged. */
    if (r.supply && ((it.a && it.a.Service) || (it.tbc || []).some(function (k) { return /^(Circuit|Supply|Service)$/.test(k); })) &&
        !rows.some(function (x) { return x.w === 'the supply'; })) {
      rows.push({ k: 'ask', w: 'the supply' });
    }
    if (!rows.length) { return ''; }
    /* Will not fit wins; then anything unresolved, so a Fits beside a Cannot
       say is never summed up as Fits (26 Oct 2026); then tight; then fits. A
       card with something unresolved and nothing failed says nothing. */
    var RANK = { no: 4, ask: 3, tight: 2, yes: 1 }, best = '';
    rows.forEach(function (x) { var k = RANK[x.k] ? x.k : 'ask'; if (!best || RANK[k] > RANK[best]) { best = k; } });
    /* With the room filter on, a piece it keeps with something unresolved says
       so, as the filter's own line promises: "Hide what will not fit" keeps
       it, and the card must not leave it looking settled beside one that
       fits (1 Nov 2026). Off, the card says nothing for it, as before. */
    if (best === 'ask') {
      return FS.room ? '<span class="vs-card-v is-ask">To confirm</span>' : '';
    }
    var W = { yes: 'Fits', tight: 'Tight', no: 'Will not fit' };
    return '<span class="vs-card-v is-' + best + '">' + W[best] + ' ' + esc(r.name || 'your room') + '</span>';
  }

  function card(it, withCat) {
    var c = BYCAT[it.cat];
    return '<div class="vs-cardw">' +
      '<a class="vs-card" href="/pages/' + it.cat + '?p=' + encodeURIComponent(it.id) + '" data-vs-link>' +
      '<span class="vs-card-shot"><img src="' + esc(asset(it.img)) + '" alt="' + esc(it.n) +
      '" loading="lazy" decoding="async" width="500" height="625"></span>' +
      '<span class="vs-card-b">' +
        (withCat ? '<span class="vs-card-cat">' + esc(c ? c.t : it.cat) + '</span>' : '') +
        '<span class="vs-card-n">' + esc(it.n) + '</span>' +
        '<span class="vs-card-b2">' + esc(it.b || '') + '</span>' +
        '<span class="vs-card-p">' + money(it.p) + '</span>' +
        cardVerdict(it) +
      '</span></a>' + markBtn(it) + cmpBtn(it) + '</div>';
  }

  /* ---------- Explore all ---------- */

  var FS = { f: {}, price: '', sort: 'featured', room: false };
  /* What the sheet's Show button says. Set by the paint that knows the number,
     read by the panel that is built in the same pass. */
  var LASTCOUNT = 0;

  /* ══════════════════════════════════════════════════ the ask, made visible ══
     Taking the star rating off the cards left a hole, and the thing that fills
     it — the verdict against your room — only appears once somebody has given
     us a room. Until 11 Sep the only way to do that was a control buried in the
     filter sidebar, which on a phone is behind a button. So the cards would
     have lost a line and gained nothing, for almost everybody.

     This is the invitation, above the grid, where the eye already is. Once the
     room exists it stops being an invitation and becomes a readout of the
     figures, because at that point the useful thing is being able to see and
     change them rather than being asked again. */
  function roomRail() {
    if (!K) { return ''; }
    if (!K.hasRoom()) {
      return '<div class="vs-rail vs-rail-ask">' +
        '<svg class="vs-rail-i" viewBox="0 0 24 24" aria-hidden="true">' +
          '<path d="M4 20.5h16M6.5 20.5V10m4 10.5V4.2m4 16.3v-7m4 7V7.4"/></svg>' +
        '<p><b>Tell us the room once.</b> The doorway, the ceiling, the circuit. ' +
        'Every model on this page then answers against your figures instead of ' +
        'you working it out one at a time.</p>' +
        '<button type="button" class="vs-b1 vs-rail-b" data-vk="room">Add your room</button>' +
        '</div>';
    }
    var r = null;
    try { r = K.room(); } catch (e) { r = null; }
    if (!r) { return ''; }
    var bits = [];
    if (r.door) { bits.push(r.door + ' in doorway'); }
    if (r.ceiling) { bits.push(feetOf(r.ceiling) + ' ceiling'); }
    if (r.supply && r.supply !== 'Not sure yet') { bits.push(r.supply); }
    if (r.slab) { bits.push(r.slab + ' in slab'); }
    return '<div class="vs-rail">' +
      '<svg class="vs-rail-i" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M4 20.5h16M6.5 20.5V10m4 10.5V4.2m4 16.3v-7m4 7V7.4"/></svg>' +
      '<p><b>' + esc(r.name || 'Your room') + '</b>' +
      (bits.length ? '<span class="vs-rail-f">' + esc(bits.join(' · ')) + '</span>' : '') + '</p>' +
      '<button type="button" class="vs-b2 vs-rail-b" data-vk="room">Change</button>' +
      '</div>';
  }
  function feetOf(inch) {
    var f = Math.floor(inch / 12), i = Math.round(inch - f * 12);
    return f + ' ft' + (i ? ' ' + i + ' in' : '');
  }

  function priceBuckets(items) {
    var lo = Infinity, hi = 0;
    items.forEach(function (i) { lo = Math.min(lo, i.p); hi = Math.max(hi, i.p); });
    if (!isFinite(lo)) { return []; }
    var steps = [], n = 4, span = (hi - lo) / n, prev = 0;
    for (var k = 1; k <= n; k++) {
      var top = k === n ? Infinity : Math.round((lo + span * k) / 10) * 10;
      steps.push({
        id: 'p' + k, lo: prev, hi: top,
        label: k === 1 ? 'Under ' + money(top)
             : (top === Infinity ? money(prev) + ' and up' : money(prev) + ' – ' + money(top))
      });
      prev = top;
    }
    return steps;
  }

  function passes(it, buckets) {
    if (FS.price) {
      var b = buckets.filter(function (x) { return x.id === FS.price; })[0];
      if (b && !(it.p >= b.lo && it.p < b.hi)) { return false; }
    }
    if (FS.room && K) {
      var bad = fitRows(it, K.room()).filter(function (r) { return r.k === 'no'; });
      if (bad.length) { return false; }
    }
    for (var lab in FS.f) {
      var on = FS.f[lab];
      if (!on || !on.length) { continue; }
      var v;
      if (lab === 'Category') { v = BYCAT[it.cat] ? BYCAT[it.cat].t : ''; }
      else { v = it.a ? it.a[lab] : ''; }
      if (on.indexOf(v) === -1) { return false; }
    }
    return true;
  }

  function sortItems(list) {
    var s = FS.sort;
    if (s === 'plh') { list.sort(function (a, b) { return a.p - b.p; }); }
    else if (s === 'phl') { list.sort(function (a, b) { return b.p - a.p; }); }
    else if (s === 'az') { list.sort(function (a, b) { return a.n.localeCompare(b.n); }); }
    else { list.sort(function (a, b) { return (b.ft - a.ft) || (b._s || 0) - (a._s || 0) || (a.p - b.p); }); }
    return list;
  }

  /* The foot of the sheet. On a phone the thing you want after setting a
     filter is the result, and the result is behind 1,400px of panel — so the
     count comes to you, as a button that closes the sheet and is already
     showing what you are about to see. */
  function panelFoot(n) {
    return '<div class="vs-pfoot">' +
      '<button type="button" class="vs-clear" data-vs-clear>Clear all</button>' +
      '<button type="button" class="vs-b1 vs-pshow" data-vs-fclose>Show ' + n +
      (n === 1 ? ' result' : ' results') + '</button></div>';
  }

  function facetGroups(cat, items) {
    var g = [];
    if (!cat) {
      var cs = [], cseen = {};
      items.forEach(function (i) {
        var t = BYCAT[i.cat] ? BYCAT[i.cat].t : i.cat;
        if (!cseen[t]) { cseen[t] = 1; cs.push(t); }
      });
      cs.sort();
      if (cs.length > 1) { g.push({ lab: 'Category', vals: cs }); }
    }
    /* Availability and Delivery were facets over invented values. A person can
       still narrow by anything the machine actually IS — the specification
       facets below — and by whether it clears their room. */
    if (cat) {
      cat.f.forEach(function (f) {
        var seen = {}, vals = [];
        items.forEach(function (i) {
          var v = i.a && i.a[f[0]];
          if (v && v !== 'Not applicable' && !seen[v]) { seen[v] = 1; vals.push(v); }
        });
        vals.sort(function (a, b) { return f[1].indexOf(a) - f[1].indexOf(b); });
        if (vals.length > 1) { g.push({ lab: f[0], vals: vals }); }
      });
    }
    return g;
  }

  function panel(buckets, groups) {
    /* On a phone this aside becomes a sheet over the page rather than a block
       that expands inside it — see the .vs-panel rules in vb-mobile.css and
       openFilters() below for why. The scrim, the header and the footer are in
       the markup on every width and cost nothing on a desktop, where they are
       display:none; building them only at mobile width would mean rebuilding
       the panel on resize. */
    var h = '<div class="vs-pscrim" data-vs-fclose></div>' +
      '<aside class="vs-panel" aria-label="Filter">' +
      '<header class="vs-phead"><h2>Filter</h2>' +
        '<button type="button" class="vs-pclose" data-vs-fclose aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" ' +
        'stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
        '</button></header>' +
      '<div class="vs-panel-in">';
    h += '<div class="vs-fh"><h2>Filter</h2><button type="button" class="vs-clear" data-vs-clear>Clear all</button></div>';
    /* Given a doorway once, the shelf can put away what will not go through
       it. Nothing is hidden on a guess: a piece we hold no width for is not
       excluded, it is asked about. The filter says exactly that (1 Nov 2026,
       his direction): it was "Only what clears it" while it kept every piece
       with something unresolved, an electrical supply nobody has confirmed
       included. It hides what will not fit, says what it keeps, and the cards
       it keeps that are not settled say "To confirm". */
    if (K) {
      if (K.hasRoom()) {
        h += '<section class="vs-fg vs-fgroom"><h3>Your room</h3><ul>' +
          '<li><label><input type="checkbox" data-vs-room' + (FS.room ? ' checked' : '') +
          '><span>Hide what will not fit</span></label></li></ul>' +
          '<p class="vs-roomp">Anything with something still to confirm, such as an electrical supply ' +
          'we have not confirmed, stays and is marked \u201cTo confirm\u201d.</p>' +
          '<button type="button" class="vs-clear vs-roomedit" data-vk="room">Change the measurements</button></section>';
      } else {
        h += '<section class="vs-fg vs-fgroom"><h3>Your room</h3>' +
          '<p class="vs-roomp">Give us the doorway, the ceiling and the supply and the shelf ' +
          'can put away what will not fit them.</p>' +
          '<button type="button" class="vs-clear" data-vk="room">Set your room</button></section>';
      }
    }
    h += '<section class="vs-fg"><h3>Price</h3><ul>';
    buckets.forEach(function (b) {
      h += '<li><label><input type="radio" name="vsprice" value="' + b.id + '"' +
           (FS.price === b.id ? ' checked' : '') + '><span>' + esc(b.label) + '</span></label></li>';
    });
    h += '</ul></section>';
    groups.forEach(function (g) {
      var on = FS.f[g.lab] || [];
      h += '<section class="vs-fg"><h3>' + esc(g.lab) + '</h3><ul>';
      g.vals.forEach(function (v) {
        h += '<li><label><input type="checkbox" data-vs-f="' + esc(g.lab) + '" value="' + esc(v) + '"' +
             (on.indexOf(v) > -1 ? ' checked' : '') + '><span>' + esc(v) + '</span></label></li>';
      });
      h += '</ul></section>';
    });
    return h + '</div>' + panelFoot(LASTCOUNT) + '</aside>';
  }

  function chips(buckets) {
    var out = [];
    if (FS.price) {
      var b = (buckets || []).filter(function (x) { return x.id === FS.price; })[0];
      out.push(['price', FS.price, b ? b.label : 'Price']);
    }
    if (FS.room) { out.push(['room', '1', 'Hiding what will not fit']); }
    Object.keys(FS.f).forEach(function (lab) {
      (FS.f[lab] || []).forEach(function (v) { out.push(['f:' + lab, v, v]); });
    });
    if (!out.length) { return ''; }
    return '<div class="vs-chips">' + out.map(function (c) {
      return '<button type="button" class="vs-chip" data-vs-drop="' + esc(c[0]) + '" data-vs-val="' +
             esc(c[1]) + '">' + esc(c[2]) + '<span aria-hidden="true">×</span></button>';
    }).join('') + '</div>';
  }

  function renderAll(catId, q) {
    var cat = BYCAT[catId] || null;
    var pool = cat ? cat.items.slice() : searchPool(q);
    var buckets = priceBuckets(pool);
    var groups = facetGroups(cat, pool);
    var list = sortItems(pool.filter(function (i) { return passes(i, buckets); }));

    var crumb = cat
      ? '<a href="/">Venerabull</a><span aria-hidden="true">/</span><a href="/pages/' + catId +
        '" data-vs-link>' + esc(cat.t) + '</a><span aria-hidden="true">/</span><span aria-current="page">Everything</span>'
      : '<a href="/">Venerabull</a><span aria-hidden="true">/</span><span aria-current="page">Search</span>';

    var h = '<div class="vs-wrap"><nav class="vs-crumb" aria-label="Breadcrumb">' + crumb + '</nav>' +
      '<div class="vs-head"><h1>' + (cat ? esc(cat.t) : (q ? 'Results for &ldquo;' + esc(q) + '&rdquo;' : 'Search')) + '</h1>' +
      '<p class="vs-sub">' + (cat
        ? 'Everything we carry, with every filter that decides between them.'
        : (pool.length ? pool.length + ' match' + (pool.length === 1 ? '' : 'es') + ' across the catalogue.' : '')) +
      '</p></div>' +
      roomRail() +
      '<button type="button" class="vs-fbtn" data-vs-fopen>Filter</button>' +
      '<div class="vs-cols">' + (function () { LASTCOUNT = list.length; return panel(buckets, groups); }()) +
      '<div class="vs-main"><div class="vs-bar"><p class="vs-count">' + list.length +
      (list.length === 1 ? ' result' : ' results') + '</p>' +
      '<label class="vs-sortw"><span>Sort</span><select data-vs-sort>' +
        [['featured','Featured'],['plh','Price: low to high'],['phl','Price: high to low'],
         ['az','Name A to Z']]
          .map(function (o) {
            return '<option value="' + o[0] + '"' + (FS.sort === o[0] ? ' selected' : '') + '>' + o[1] + '</option>';
          }).join('') +
      '</select></label></div>' + chips(buckets);

    if (!list.length) {
      /* An empty shelf that does not say why is a dead end. When the room is
         what emptied it, name the measurement that did it — that is a useful
         answer, and often the reason somebody came. */
      var why = '';
      if (FS.room && K && pool.length) {
        var tally = {};
        pool.forEach(function (i) {
          fitRows(i, K.room()).forEach(function (r) {
            if (r.k === 'no') { tally[r.w || r.t] = (tally[r.w || r.t] || 0) + 1; }
          });
        });
        var top = Object.keys(tally).sort(function (a, b) { return tally[b] - tally[a]; })[0];
        if (top) {
          why = 'The same thing rules out every one of them: <b>' + esc(top) + '</b>. ' +
                (top === 'the supply'
                  ? 'An electrician settles that in a morning, and it changes what the whole shelf can do for you.'
                  : 'Worth knowing before you go any further.');
        }
      }
      /* The room is named only when the room is what emptied it (the review of
         bc162f4): a Capacity and a Form with no model between them is not a
         room that nothing fits. */
      var roomDid = FS.room && K && pool.length && (function () {
        FS.room = false;
        var left = pool.filter(function (i) { return passes(i, buckets); }).length;
        FS.room = true;
        return left > 0;
      })();
      h += '<div class="vs-none"><h2>' + (pool.length
            ? (roomDid ? 'Nothing here will fit your room.' : 'Nothing matches all of that.')
            : 'Nothing on the shelf answers to that yet.') + '</h2>' +
        '<p>' + (why || (pool.length
            ? 'Drop a filter and the shelf comes back.'
            : 'Try a category, or tell us what you are trying to fit &mdash; if it exists we can usually source it.')) + '</p>' +
        '<p><button type="button" class="vs-b1" data-vs-clear>Clear all filters</button>' +
        (FS.room && K ? ' <button type="button" class="vs-b2" data-vk="room">Change the measurements</button>' : '') +
        '</p></div>';
    } else {
      h += '<div class="vs-grid">' + list.map(function (i) { return card(i, !cat); }).join('') + '</div>';
    }
    return h + '</div></div></div>';
  }


  /* ---------- does it clear ----------

     The homepage says: tell us the room, the doorway or the circuit and we
     will tell you what clears it. That promise belongs where the decision is
     made, not only in the chat.

     It answers from the specification and from nothing else. Where the shelf
     does not carry a figure it says so and hands to a person — which is the
     only honest thing to do with a number nobody has measured. */

  function inches(v) {
    var s = String(v == null ? '' : v);
    var ft = /(\d+(?:\.\d+)?)\s*(?:ft|foot|feet|')/i.exec(s);
    var ins = /(\d+(?:\.\d+)?)\s*(?:in|inch|inches|")/i.exec(s);
    var t = 0;
    if (ft) { t += parseFloat(ft[1]) * 12; }
    if (ins) { t += parseFloat(ins[1]); }
    return t || null;
  }
  var AMPS = { '120 V standard outlet': 0, '240 V 20 A': 20, '240 V 30 A': 30,
               '240 V 40 A': 40, '240 V 50 A': 50, 'Three phase': 999 };

  function fitRows(it, room) {
    var a = it.a || {}, out = [];

    /* the doorway */
    var w = inches(a.Width) || inches(a.Depth) || inches(a['Closed height']);
    var wLab = a.Width ? 'Width' : (a.Depth ? 'Depth' : 'Closed height');
    if (room.door && w) {
      var slack = room.door - w;
      out.push({
        k: slack >= 4 ? 'yes' : (slack >= 0 ? 'tight' : 'no'), w: 'the doorway',
        t: 'Through a ' + room.door + " in doorway",
        s: wLab + ' is ' + a[wLab] + '. ' + (slack >= 4
            ? 'Four inches of room or better.'
            : (slack >= 0
              ? 'It goes through with ' + Math.round(slack) + ' in to spare — crated it will not, so it comes off the pallet at the door.'
              : 'It does not, uncrated or otherwise. It would need to come in another way.'))
      });
    } else if (room.door) {
      out.push({ k: 'ask', w: 'the doorway', t: 'Through a ' + room.door + ' in doorway',
        s: 'We do not carry a width for this piece yet. Ask and we confirm it from the manufacturer drawing before anything ships.' });
    }

    /* the ceiling */
    var ch = inches(a.Ceiling) || inches(a['Bay height']);
    if (room.ceiling && ch) {
      out.push({
        k: room.ceiling >= ch ? 'yes' : 'no', w: 'the ceiling',
        t: 'Under a ' + room.ceiling + ' in ceiling',
        s: 'It wants ' + (a.Ceiling || a['Bay height']) + '. ' +
           (room.ceiling >= ch ? 'Yours clears it.' : 'Yours is ' + Math.round(ch - room.ceiling) + ' in short.')
      });
    }

    /* the power */
    if (room.supply) {
      var need = a.Circuit || a.Supply || '';
      var mine = AMPS[room.supply];
      /* a supply this check does not know goes to the rule below, which asks */
      if (need && /hardwired/i.test(need) && !/(\d+)\s*A/.test(need) &&
          (room.supply === 'Not sure yet' || typeof mine === 'number')) {
        /* A hardwired supply with no breaker rating (1 Nov 2026, his
           direction; 506bf70's accepted behaviour, kept to this one case and
           moved in all three engines with the fixture). It is wired in, so a
           standard outlet is never said to run it, "Not sure yet" included. A
           matching voltage alone does not establish that a circuit carries
           it, because the listing gives no amps, and three phase says neither
           the voltage nor the amps. An established mismatch still fails. */
        var hwWired = 'It is wired in, not plugged in, so an electrician makes the connection, and the ' +
                      'manufacturer\'s installation instructions set the circuit it needs.';
        var hwThree = 'Three phase on its own does not say the voltage or the amps available, so an electrician ' +
                      'confirms it at the panel.';
        var hwKind = 'ask', hwSays = hwWired;
        if (room.supply === 'Not sure yet') {
          /* to confirm, wired in */
        } else if (/three phase/i.test(need)) {
          hwKind = mine === 999 ? 'ask' : 'no';
          hwSays = mine === 999 ? hwThree : 'Three phase is not something a house usually has.';
        } else if (/240/.test(need) && !(mine >= 20)) {
          hwKind = 'no';
          hwSays = 'It needs a 240 V circuit adding.';
        } else if (/240/.test(need)) {
          hwSays = mine === 999 ? hwThree
            : 'Yours is ' + room.supply + '. The listing does not give the amps it needs, so the ' +
              'manufacturer\'s installation instructions decide whether yours carries it.';
        }
        out.push({ k: hwKind, w: 'the supply', t: 'On the supply you have', s: 'It runs on ' + need + '. ' + hwSays });
      } else if (need) {
        /* Every other listed circuit or supply (1 Nov 2026, his direction on
           cdf06ae), answered from the listing's own figures and the supply
           the shopper chose, and nothing else. It clears only when the
           supply is what the listing asks for: a 120 V plug-in on a standard
           outlet, or a 240 V circuit of exactly the amps listed, and a
           matching rating is not approval to install. It fails only where a
           figure the shopper gave conflicts with the listing: another
           voltage, or fewer amps than listed. The rest is to confirm: three
           phase on its own (no voltage, no amps), a three-phase listing on a
           circuit of its voltage (a circuit's figures do not say its phase,
           so the branch phase is confirmed), a listing without amps, a
           larger breaker than listed (the listing sets no largest), a 120 V
           piece on a 240 V circuit, a supply this check does not know, and
           gas, which no electrical supply answers. */
        var lead = (a.Circuit ? 'It needs ' : 'It runs on ') + need + '. ';
        var nv = /(\d+)\s*V/.exec(need), na = /(\d+)\s*A/.exec(need);
        var volts = nv ? parseInt(nv[1], 10) : 0, amps = na ? parseInt(na[1], 10) : 0;
        var plug = /plug-in|standard outlet/i.test(need);
        var sk = 'ask', ss;
        if (/gas/i.test(need)) {
          ss = 'An electrical supply does not settle a gas connection; the manufacturer\'s installation ' +
               'instructions set what it needs.';
        } else if (room.supply === 'Not sure yet') {
          ss = plug && volts === 120 && !amps
            ? 'It plugs into a standard outlet, so check there is one where it goes.'
            : 'Worth checking the panel before you order — an electrician can read it in a minute.';
        } else if (typeof mine !== 'number' || !volts) {
          ss = 'This check cannot compare it with the supply you gave, so an electrician confirms it against the listing.';
        } else if (mine === 999) {
          ss = plug && volts === 120 && !amps
            ? 'It plugs into a standard outlet, so check there is one where it goes.'
            : 'Three phase on its own does not say the voltage or the amps available, so an electrician ' +
              'confirms it at the panel.';
        } else if (/three phase/i.test(need)) {
          if (volts !== (mine === 0 ? 120 : 240)) {
            sk = 'no';
            ss = 'It is listed for ' + volts + ' V three phase and yours is ' + (mine === 0 ? '120' : '240') +
                 ' V, so as listed it needs a ' + volts + ' V three-phase supply.';
          } else if (amps && mine > 0 && mine < amps) {
            sk = 'no'; ss = 'Yours is ' + mine + ' A — it would need upgrading.';
          } else {
            ss = 'The voltage matches, but ' + room.supply + ' does not say its phase, so an electrician confirms ' +
                 'the branch phase at the panel.';
          }
        } else if (volts === 120) {
          if (mine !== 0) {
            ss = plug ? 'Yours is ' + room.supply + ', not a standard outlet, so the outlet where it goes needs confirming.'
                      : 'Yours is ' + room.supply + ', a different voltage, so the circuit needs confirming.';
          } else if (plug && !amps) {
            sk = 'yes'; ss = 'A standard outlet runs it.';
          } else if (amps) {
            ss = 'A standard outlet does not say its amps, so an electrician checks its circuit against the ' +
                 amps + ' A listed.';
          } else {
            ss = 'The listing does not say it plugs into a standard outlet or give its amps, so the ' +
                 'manufacturer\'s sheet sets the circuit it needs.';
          }
        } else if (volts !== 240) {
          sk = 'no';
          ss = 'It is listed for ' + volts + ' V and yours is ' + (mine === 0 ? '120' : '240') + ' V, so as listed ' +
               'it needs a ' + volts + ' V supply.';
        } else if (mine === 0) {
          sk = 'no';
          ss = a.Circuit ? 'A standard outlet will not run it; this is a circuit an electrician adds.'
                         : 'It needs a 240 V circuit adding.';
        } else if (!amps) {
          ss = 'Yours is ' + room.supply + '. The listing does not give the amps it needs, so the ' +
               'manufacturer\'s installation instructions decide whether yours carries it.';
        } else if (mine < amps) {
          sk = 'no'; ss = 'Yours is ' + mine + ' A — it would need upgrading.';
        } else if (mine === amps) {
          sk = 'yes';
          ss = 'Your circuit matches the listed rating. The manufacturer\'s installation instructions still apply.';
        } else {
          ss = 'Yours is ' + mine + ' A, more than the ' + amps + ' A it lists, and the listing does not say a ' +
               'larger breaker is allowed, so the manufacturer\'s installation instructions decide.';
        }
        out.push({ k: sk, w: 'the supply', t: 'On the supply you have', s: lead + ss });
      }
    }

    /* the route in

       Never a confirmed fit (26 Oct 2026). A weight on the sheet is not a plan
       for carrying it: with no weight the answer is unresolved and no handling
       advice is invented; with one, the weight is repeated exactly as the sheet
       states it and how it goes up is a question to settle. */
    if (room.stairs && room.stairs !== 'No stairs') {
      var stated = String(a.Weight == null ? '' : a.Weight).trim() !== '';
      var heavy = /1,500|and over|800-1,500/.test(String(a.Weight || ''));
      out.push({
        k: 'ask', w: 'the route in',
        t: room.stairs === 'A full flight' ? 'Up a flight of stairs' : 'Up a few steps',
        s: !stated
          ? 'Our sheet gives no weight for this piece, so its weight and the plan for handling it on the stairs are unconfirmed.'
          : 'It weighs ' + a.Weight + '. ' + (heavy
             ? 'At that weight stairs are a conversation before the truck is booked, not on the day.'
             : 'How it goes up the stairs, and how many people that takes, is a question to settle with us before the truck is booked.')
      });
    }

    /* the slab

       30 Oct 2026, Nasser's direction: a thickness is never an approval.
       The slab entry is the one our sheet gives, repeated exactly as the
       sheet gives it; it is not a verified manufacturer requirement and
       nothing here says it is. It is compared only when it is one
       thickness: a single positive number with one unit and no other
       figure, sign or word, in at most 15 significant digits (13 in feet,
       so twelve times it still fits in 15 and is never rounded up). A room's
       thickness given as text is read the same way. Thinner than the
       sheet's figure is a "no". Meeting it is still unresolved, because a
       thickness does not show whether a slab is suitable. A room's number
       is the person's exact figure only when the app saved it as one
       (slabExact); any other number is a record that may have been rounded
       to the inch, so it is never said to meet the figure, and it is
       thinner only where an inch of rounding could not change that. A
       piece whose sheet gives no slab gets no slab row: nothing is
       invented for it. */
    if (a.Slab != null) {
      var oneThick = function (v) {
        var m = /^\s*(\d+(?:\.\d+)?)\s*(in|inch|inches|"|ft|foot|feet|')\s*$/i.exec(String(v == null ? '' : v));
        var ft = !!m && /^(?:ft|foot|feet|')$/i.test(m[2]);
        if (!m || m[1].replace('.', '').replace(/^0+/, '').length > (ft ? 13 : 15)) { return null; }
        var n = Number((parseFloat(m[1]) * (ft ? 12 : 1)).toPrecision(15));
        return isFinite(n) && n > 0 ? n : null;
      };
      var listed = String(a.Slab).trim();
      var needSlab = oneThick(listed);
      var exact = typeof room.slab === 'string' || room.slabExact === true;
      var mySlab = typeof room.slab === 'number'
        ? (isFinite(room.slab) && room.slab > 0 ? room.slab : null) : oneThick(room.slab);
      var thinner = !!(mySlab && needSlab && (exact ? mySlab < needSlab : mySlab + 1 <= needSlab));
      out.push({
        k: thinner ? 'no' : 'ask', w: 'the slab',
        t: 'On the slab you have',
        s: (listed ? 'Our sheet gives the slab as ' + listed + '. '
                   : 'Our sheet names a slab for this piece but gives no figure. ') +
           (!mySlab
             ? 'No usable slab thickness is given for this room, so whether the slab is suitable is unconfirmed.'
             : (exact ? 'Yours is ' : 'Yours is recorded as ') + mySlab + ' in' + (!needSlab
               ? ', but our sheet does not give one thickness to compare it with, so whether the slab is suitable is unconfirmed.'
               : (thinner
                 ? ', thinner than that figure.'
                 : (exact
                   ? ', which meets that figure, but a thickness alone does not show whether a slab is suitable, so that is unconfirmed.'
                   : ', which may have been rounded when it was saved, so whether it meets that figure is unconfirmed, and so is whether the slab is suitable.'))))
      });
    }
    return out;
  }

  var VERDICT = { yes: 'Clears', tight: 'Tight', no: 'Does not clear', ask: 'Ask us' };

  /* One line, beside the price, where the stock state used to be. It links to
     the full answer rather than repeating it. When there is no room yet it
     offers to take one — the same offer the rail above the grid makes, because
     somebody can arrive on a product page without passing a grid at all. */
  function buyVerdict(it) {
    if (!K) { return ''; }
    var room = null;
    try { room = K.room(); } catch (e) { room = null; }
    var any = false;
    for (var k in room) { any = true; break; }
    if (!any) {
      return '<p class="vs-buyv is-cold">' +
        '<button type="button" class="vs-buyv-b" data-vk="room">Will it fit your room?</button>' +
        '</p>';
    }
    /* the product page's rows (pdRows): the engine's, with what it cannot establish withheld */
    var rows = pdRows(it, room);
    if (!rows.length) { return ''; }
    /* the card's order: no, then unresolved, then tight, then fits */
    var RANK = { no: 4, ask: 3, tight: 2, yes: 1 }, best = '';
    rows.forEach(function (x) { var k = RANK[x.k] ? x.k : 'ask'; if (!best || RANK[k] > RANK[best]) { best = k; } });
    /* The uncertain headline reads as a sentence before the room's name or
       "your room" (1 Nov 2026, his check of 6b1e623: "Cannot say yet your
       room"); the other three are as they were. */
    var W = { yes: 'Fits', tight: 'Tight', no: 'Will not fit', ask: 'Fit needs confirming for' };
    var why = null;
    rows.forEach(function (x) { if (!why && x.k === best) { why = x; } });
    return '<p class="vs-buyv is-' + best + '">' +
      '<span class="vs-buyv-v">' + W[best] + ' ' + esc(room.name || 'your room') + '</span>' +
      (why ? '<span class="vs-buyv-w">' + esc(why.t) + ' — ' + esc(why.s) + '</span>' : '') +
      '</p>';
  }

  function fitBlock(it) {
    if (!K) { return ''; }
    var room = K.room();
    var any = false;
    for (var k in room) { any = true; break; }
    if (!any) {
      return '<section class="vs-fit vs-fit--cold">' +
        '<h2>Will it fit?</h2>' +
        '<p>Give us the doorway, the ceiling and the supply once. Every piece on the site answers ' +
        'for your room after that, this one included.</p>' +
        '<button type="button" class="vs-b2" data-vk="room">Set your room</button></section>';
    }
    var rows = pdRows(it, room);
    if (!rows.length) {
      return '<section class="vs-fit vs-fit--cold"><h2>Will it fit?</h2>' +
        '<p>Nothing you have given us bears on this piece. Add the doorway or the supply and we will answer for it.</p>' +
        '<button type="button" class="vs-b2" data-vk="room">Your room</button></section>';
    }
    return '<section class="vs-fit"><div class="vs-fith"><h2>In your room</h2>' +
      '<button type="button" class="vs-fitedit" data-vk="room">Change</button></div>' +
      '<ul class="vs-fitl">' + rows.map(function (r) {
        return '<li class="is-' + r.k + '"><span class="vs-fitv">' + VERDICT[r.k] + '</span>' +
          '<span class="vs-fitt"><b>' + esc(r.t) + '</b><em>' + esc(r.s) + '</em></span></li>';
      }).join('') + '</ul>' +
      '<p class="vs-fitn">Measured against the specification, not against a crate. We confirm the crate ' +
      'and the route with you before anything is booked.</p></section>';
  }

  /* ---------- the product page ---------- */

  function optDeltas(it) {
    /* The ladder is baked into the catalogue, so the configurator and the
       grid quote the same money. Older data without it falls back to a
       straight percentage step. */
    return (it.o || []).map(function (o) {
      if (o.d) { return o.d; }
      var di = Math.max(0, o.v.indexOf(it.a ? it.a[o.n] : null));
      return o.v.map(function (v, vi) { return Math.round((it.p * 0.025 * (vi - di)) / 10) * 10; });
    });
  }

  function priceOf(it, deltas, chosen) {
    var t = it.p;
    chosen.forEach(function (c, i) { t += deltas[i][c]; });
    return t;
  }
  function configLine(it, chosen) {
    return (it.o || []).map(function (o, i) { return o.v[chosen[i]]; }).join(' · ');
  }
  /* The facts follow the selection (1 Nov 2026, his live check of 2ed347a: a
     Linden chosen for a wall and a 240 V circuit still said "Recessed" and
     "120 V" in About this piece and "Install · Recessed" in the
     Specification). From 506bf70 and its predecessors: cfgKey is the chosen
     index of every option, or '' for the model as listed (598fef7);
     chosenAttrs is the option part of configured() (dc6f9c0) with the same
     index and default rules, and nothing else: each option's word as the
     Specification shows it, the listing's own wording while that option is
     on the listing. The fit state configured() also builds has no reader on
     this page, so it is not carried; the room verdicts read the listing. */
  function cfgKey(it, chosen) {
    var moved = false;
    var key = (it.o || []).map(function (o, i) {
      var at = Math.max(0, o.v.indexOf(it.a ? it.a[o.n] : null));
      var c = chosen && chosen[i] != null ? +chosen[i] : at;
      if (c !== at) { moved = true; }
      return c;
    }).join('-');
    return moved ? key : '';
  }
  function chosenAttrs(it, chosen) {
    var src = it.a || {}, a = {};
    (it.o || []).forEach(function (o, i) {
      var at = Math.max(0, o.v.indexOf(src[o.n]));
      var c = chosen ? parseInt(chosen[i], 10) : at;
      if (isNaN(c) || c < 0 || c >= o.v.length) { c = at; }
      a[o.n] = c !== at ? o.v[c] : src[o.n];
    });
    return a;
  }
  /* A configured piece answers for itself in the room verdicts (1 Nov 2026,
     his check of 79d5dec: a Linden chosen as 240 V hardwired was still
     answered as the listing, "A standard outlet runs it"). 506bf70's
     configured(), unchanged, and now with a reader: fitRows, through
     buyVerdict and fitBlock.

     Every option sets the attribute it names, so the supply the shopper
     chose is what the supply check reads. A figure no option sets is the
     listing's figure for the listed configuration; once any option moves
     away from it, the figure is not vouched for any more, so it comes out of
     the attributes and into u, where fitRows says it needs confirming
     instead of answering from it. Nothing is guessed for the new
     configuration, and the listed configuration comes back exactly as
     listed. l is the listed value of each option that moved. The slab is
     kept out of u: fitRows reads it, and its row is never a pass. */
  function configured(it, chosen) {
    var src = it.a || {}, a = {}, u = {}, set = {}, l = [], k;
    for (k in src) { a[k] = src[k]; }
    (it.o || []).forEach(function (o, i) {
      var at = Math.max(0, o.v.indexOf(src[o.n]));
      var c = chosen ? parseInt(chosen[i], 10) : at;
      if (isNaN(c) || c < 0 || c >= o.v.length) { c = at; }
      set[o.n] = 1;
      if (c !== at) { l.push(o.v[at]); a[o.n] = o.v[c]; }
    });
    if (l.length) {
      ['Width', 'Depth', 'Closed height', 'Ceiling', 'Bay height', 'Circuit', 'Supply', 'Service', 'Weight',
       'Flue', 'Transfer', 'Phase', 'Water', 'Dynamic load', 'Anchoring', 'Install', 'Mount', 'Connection'].forEach(function (f) {
        if (!set[f] && a[f] != null) { u[f] = a[f]; delete a[f]; }
      });
    }
    return { id: it.id, n: it.n, cat: it.cat, a: a, u: u, l: l, tbc: it.tbc };
  }
  /* Redraw the buy-box verdict and "In your room" for the configuration in
     view (506bf70). Both answer from configured(), so a choice made in the
     configurator and a room given afterwards are answered for together, and
     the two places never disagree. The buy-box line keeps a hidden
     placeholder when it has nothing to say, so the next redraw has somewhere
     to land. */
  /* What the product page says about the room, for the piece in view (1 Nov
     2026, his direction on 79d5dec). The shared fit engine (fitRows, with its
     copies in the app and in Swift) is not changed here: a change to its rules
     moves in all three, with the fixture, or not at all. This page hands it the
     configuration chosen (configured()) and then withholds any positive the
     engine cannot establish for that configuration or that circuit, so the
     page never says a piece clears what the catalogue cannot vouch for:
       - the supply clears only a plug-in listing on a standard outlet, or a
         240 V figure that states its amps on a 240 V circuit of exactly those
         amps (1 Nov 2026: a larger breaker is to confirm, as the engine now
         says itself); any other positive the engine gives (a hardwired or other supply
         on an outlet, a listing without amps, three phase, a plug-in on
         something other than an outlet, another voltage) is confirmed with the
         shopper before an order instead;
       - a power figure the engine does not read (a hot tub's Service) is the
         same: to confirm, never silently left out of a headline;
       - a figure the configuration cannot vouch for (configured()'s u) is said
         as listed and to confirm: the ceiling and the supply, which the engine
         would otherwise leave out, and the doorway and the weight, which it
         would otherwise call missing.
     The engine's negatives stand as it gives them. */
  function pdRows(it, room) {
    var rows = fitRows(it, room), a = it.a || {}, u = it.u || {};
    var CONFIRM = ' We confirm it with you before an order.';
    var has = function (w) { return rows.some(function (r) { return r.w === w; }); };
    var place = function (row, after) {
      var at = 0;
      rows.forEach(function (r, i) { if (after.indexOf(r.w) >= 0) { at = i + 1; } });
      rows.splice(at, 0, row);
    };
    rows.forEach(function (r) {
      if (r.w === 'the supply') {
        var need = a.Circuit || a.Supply || '';
        var mine = AMPS[room.supply];
        var ampM = /(\d+)\s*A/.exec(need);
        var plugNeed = !a.Circuit && /plug-in|standard outlet/i.test(need) && !/240|three phase/i.test(need);
        var plugOk = plugNeed && mine === 0;
        var ampsOk = /240/.test(need) && !!ampM && typeof mine === 'number' && mine > 0 && mine < 999 &&
          mine === parseInt(ampM[1], 10);
        /* a positive it cannot establish, or a standard outlet said to run
           what does not plug in (the engine says so even on "Not sure yet") */
        if ((r.k === 'yes' && !plugOk && !ampsOk) || (!plugNeed && /standard outlet runs it/i.test(r.s))) {
          if (r.k === 'yes') { r.k = 'ask'; }
          r.s = (a.Circuit ? 'It needs ' + a.Circuit + '. ' : 'It runs on ' + need + '. ') +
            (mine === 999 ? 'Three phase on its own does not say the voltage or the amps available.'
            : (/240/.test(need) && !ampM ? 'The listing does not give the amps it needs, so whether yours carries it is not something the listing settles.'
            : (/hardwired/i.test(need) ? 'It is wired in, not plugged in, so an electrician makes the connection, and the ' +
                'manufacturer\'s installation instructions set the circuit it needs.'
            : (/plug-in/i.test(need) ? 'Yours is ' + room.supply + ', not a standard outlet, so the outlet where it goes needs confirming.'
            : (a.Circuit ? 'Yours is ' + room.supply + ', a different voltage, so the circuit needs confirming.'
            : 'The listing does not say it plugs into a standard outlet, so that is not assumed.'))))) + CONFIRM;
        }
      }
      if (r.w === 'the doorway' && r.k === 'ask' && (u.Width || u.Depth || u['Closed height'])) {
        var ul = u.Width ? 'Width' : (u.Depth ? 'Depth' : 'Closed height');
        r.s = 'As listed, its ' + ul.toLowerCase() + ' is ' + u[ul] + '. We do not hold the figure for the configuration ' +
          'you have chosen, so the doorway needs confirming.' + CONFIRM;
      }
      if (r.w === 'the route in' && u.Weight && String(a.Weight == null ? '' : a.Weight).trim() === '') {
        r.s = 'As listed, it weighs ' + u.Weight + '. We do not hold the weight for the configuration you have chosen, ' +
          'so its weight and the plan for handling it on the stairs are unconfirmed.';
      }
    });
    if (room.ceiling && !has('the ceiling') && (inches(u.Ceiling) || inches(u['Bay height']))) {
      place({ k: 'ask', w: 'the ceiling', t: 'Under a ' + room.ceiling + ' in ceiling',
        s: 'As listed, it wants ' + (u.Ceiling || u['Bay height']) + '. We do not hold the figure for the ' +
           'configuration you have chosen, so the ceiling needs confirming.' + CONFIRM }, ['the doorway']);
    }
    if (room.supply && !has('the supply')) {
      if (u.Circuit || u.Supply || u.Service) {
        place({ k: 'ask', w: 'the supply', t: 'On the supply you have',
          s: 'As listed, it ' + (u.Circuit ? 'needs ' + u.Circuit : 'runs on ' + (u.Supply || u.Service)) + '. We do not hold ' +
             'the figure for the configuration you have chosen, so the supply needs confirming.' + CONFIRM },
          ['the doorway', 'the ceiling']);
      } else if (a.Service) {
        place({ k: 'ask', w: 'the supply', t: 'On the supply you have',
          s: 'It needs ' + a.Service + '. Whether yours carries it is not something this check reads yet.' + CONFIRM },
          ['the doorway', 'the ceiling']);
      } else if ((it.tbc || []).some(function (k) { return /^(Circuit|Supply|Service)$/.test(k); })) {
        /* A power figure the catalogue says is not confirmed (its tbc, 1 Nov
           2026, his direction on the Loyly): there is nothing to answer from,
           and silence would let the doorway or nothing at all stand as the
           answer, so the supply is to confirm on every supply given. */
        place({ k: 'ask', w: 'the supply', t: 'On the supply you have',
          s: 'We have not confirmed the electrical supply it needs, so whether yours carries it is not ' +
             'something we can say yet.' + CONFIRM },
          ['the doorway', 'the ceiling']);
      }
    }
    return rows;
  }
  function redrawFit(it) {
    var cf = configured(it, PDC);
    [['.vs-buyv', buyVerdict(cf) || '<p class="vs-buyv" hidden></p>'], ['.vs-fit', fitBlock(cf)]]
      .forEach(function (x) {
        var old = MOUNT.querySelector(x[0]);
        if (!old || !x[1]) { return; }
        var box = document.createElement('div');
        box.innerHTML = x[1];
        if (box.firstChild) { old.replaceWith(box.firstChild); }
      });
  }
  /* The listing's blurb ("Recessed, 120 V, flame on glass media") describes
     the model as listed, so it shows only while the selection IS the listing
     (89927b1): under the name, in the band and as the first bullets of About
     this piece. Any other selection hides all three; the configured price and
     the Specification rows say what is chosen. Hidden, not rewritten, so
     choosing the listing again restores it exactly. */
  function blurbOn(it, chosen) { return !cfgKey(it, chosen); }
  /* What the catalogue says is not confirmed (its tbc, 1 Nov 2026, his
     direction on the Loyly), in About this piece in every configuration and in
     the house form of the delivery and warranty lines, because the blurb that
     says it is hidden once the selection is not the listing. */
  function tbcBullet(it) {
    var W = { Heater: 'heater output', Circuit: 'electrical supply', Supply: 'electrical supply',
              Service: 'electrical service' }, seen = {}, ws = [];
    (it.tbc || []).forEach(function (k) {
      var w = W[k] || String(k).toLowerCase();
      if (!seen[w]) { seen[w] = 1; ws.push(w); }
    });
    if (!ws.length) { return ''; }
    var last = ws.pop(), s = (ws.length ? ws.join(', ') + ' and ' : '') + last;
    return '<li data-vs-tbc>' + esc(s.charAt(0).toUpperCase() + s.slice(1)) +
      ', confirmed with you before any order</li>';
  }
  /* The written enquiry about this exact model (1 Nov 2026, his direction):
     "Send a message" and the note's "Send the details" open the contact form
     with the model and the options on the screen already in the editable
     message. Only public catalogue values travel: the model id, every
     option's index in the page's own ?c= form and every option's word, the
     listed selection included, so vb-enquiry.js on the contact page can find
     out a link whose options the catalogue has since changed and leave the
     box alone. Never the room, a measurement or anything the shopper typed.
     A model with no options carries "&c=&w=", both present and empty. The
     link lands on the form itself, #contact_form (the id Shopify gives the
     contact form); the fragment is not part of the query vb-enquiry.js reads.
     Reviewed as sendHref in c7a1927 and 8513ab8; the fragment is new here. */
  function sendHref(it, chosen) {
    var opts = it.o || [];
    var idx = opts.map(function (o, i) {
      var at = Math.max(0, o.v.indexOf(it.a ? it.a[o.n] : null));
      var c = chosen && chosen[i] != null ? +chosen[i] : at;
      return o.v[c] != null ? c : at;
    });
    return '/pages/contact?p=' + encodeURIComponent(it.id) + '&c=' + idx.join('-') +
      '&w=' + encodeURIComponent(idx.map(function (c, i) { return opts[i].v[c]; }).join('\u001f')) +
      '#contact_form';
  }

  function renderProduct(it) {
    var cat = BYCAT[it.cat];
    var shots = [it.img].concat(it.g || []);
    var deltas = optDeltas(it);
    var chosen = (it.o || []).map(function (o) { return Math.max(0, o.v.indexOf(it.a ? it.a[o.n] : null)); });
    /* A configuration arrived at over ten minutes should survive being sent to
       somebody. It rides in the query string, so the link is the thing. */
    var fromUrl = (qs().c || '').split('-');
    (it.o || []).forEach(function (o, i) {
      var v = parseInt(fromUrl[i], 10);
      if (!isNaN(v) && v >= 0 && v < o.v.length) { chosen[i] = v; }
    });
    var configurable = !!(it.o && it.o.length);
    var BLURB = ' data-vs-blurb' + (blurbOn(it, chosen) ? '' : ' hidden');
    var cfgA = chosenAttrs(it, chosen);
    /* The room verdicts answer for what is chosen, not for the listing. */
    var cfg = configured(it, chosen);
    PDC = chosen.slice();

    var h = '<div class="vs-wrap vs-pd" data-vs-pd="' + esc(it.id) + '">' +
      '<nav class="vs-crumb" aria-label="Breadcrumb"><a href="/">Venerabull</a><span aria-hidden="true">/</span>' +
      '<a href="/pages/' + it.cat + '" data-vs-link>' + esc(cat.t) + '</a><span aria-hidden="true">/</span>' +
      '<a href="/pages/' + it.cat + '?view=all" data-vs-link>Everything</a><span aria-hidden="true">/</span>' +
      '<span aria-current="page">' + esc(it.n) + '</span></nav>' +

      '<div class="vs-pcols">' +
      '<div class="vs-gal">' +
        '<div class="vs-thumbs">' + shots.map(function (s, i) {
          return '<button type="button" class="vs-th' + (i ? '' : ' is-on') + '" data-vs-th="' + i +
                 '" aria-label="View ' + (i + 1) + '"><img src="' + esc(asset(s)) +
                 '" alt="" loading="lazy" width="120" height="150"></button>';
        }).join('') + '</div>' +
        '<figure class="vs-stage"><button type="button" class="vs-stageb" data-vs-zoom="0" ' +
        'aria-label="See it larger"><img data-vs-stage src="' + esc(asset(shots[0])) + '" alt="' +
        esc(it.n) + '" width="1000" height="1250">' +
        '<span class="vs-zoomh"><svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">' +
        '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.6-3.6M11 8.4v5.2M8.4 11h5.2"/></svg>Larger</span>' +
        '</button></figure>' +
      '</div>' +

      '<div class="vs-buy">' +
        '<p class="vs-eyebrow">' + esc(cat.t) + '</p>' +
        '<h1 class="vs-pn">' + esc(it.n) + '</h1>' +
        '<p class="vs-pblurb"' + BLURB + '>' + esc(it.b) + '</p>' +
        '<p class="vs-pprice"><span data-vs-price>' + money(priceOf(it, deltas, chosen)) + '</span>' +
          (configurable ? '<span class="vs-pfrom">as configured</span>' : '') + '</p>' +
        ((it.o || []).map(function (o, oi) {
          return '<fieldset class="vs-opt"><legend>' + esc(o.n) + '</legend><div class="vs-opts">' +
            o.v.map(function (v, vi) {
              var d = deltas[oi][vi];
              return '<label class="vs-o' + (vi === chosen[oi] ? ' is-on' : '') + '">' +
                '<input type="radio" name="vso' + oi + '" data-vs-o="' + oi + '" value="' + vi + '"' +
                (vi === chosen[oi] ? ' checked' : '') + '>' +
                '<span class="vs-ov">' + esc(v) + '</span>' +
                '<span class="vs-od">' + (d === 0 ? 'Included' : (d > 0 ? '+' + money(d) : '−' + money(-d))) +
                '</span></label>';
            }).join('') + '</div></fieldset>';
        }).join('')) +
        /* A stock state, a dated delivery and a delivery level all used to sit
           here. None of the three is settled, and a date with a weekday on it is
           the most specific promise a shop can make.

           What goes in their place is the one thing at this point in the page
           that IS settled and IS about this buyer: whether it clears their room.
           It is the same answer the long fit section below gives, said in one
           line at the moment the price is read, because that is when somebody
           decides whether to keep reading. */
        (buyVerdict(cfg) || '<p class="vs-buyv" hidden></p>') +
        '<div class="vs-deliv">' +
          /* Every model here is presentation stock (1 Nov 2026, his review): no
             supplier has confirmed a delivery service or a warranty for any of
             them, so the page says what is confirmed with the shopper before an
             order, not how freight or warranty registration will go. */
          '<p class="vs-ship">Before any order we confirm with you the delivery service and its level, ' +
          'and the warranty terms that apply and how registration works.</p>' +
        '</div>' +
        '<div class="vs-acts">' +
          '<button type="button" class="vs-b1" data-vs-ask>' +
            (configurable ? 'Confirm this configuration' : 'Check availability') + '</button>' +
          /* The second action is a written enquiry about this exact selection,
             from the same sendHref as the note's "Send the details", so the two
             cannot differ; the option handler keeps both in step. */
          '<a class="vs-b2" href="' + esc(sendHref(it, chosen)) + '" data-vs-send>Send a message</a>' +
        '</div>' +
        /* Nobody spends nine thousand pounds without showing somebody. */
        '<div class="vs-side">' +
          (K ? '<button type="button" class="vs-sidea' + (K.isSaved(it.id) ? ' is-on' : '') +
            '" data-vs-save="' + esc(it.id) + '" aria-pressed="' + (K.isSaved(it.id) ? 'true' : 'false') + '">' +
            '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">' +
            '<path d="M12 20.5 4.2 12.9a4.6 4.6 0 1 1 6.5-6.5l1.3 1.3 1.3-1.3a4.6 4.6 0 1 1 6.5 6.5Z"/></svg>' +
            '<span>' + (K.isSaved(it.id) ? 'Saved' : 'Save this') + '</span></button>' : '') +
          (K ? '<button type="button" class="vs-sidea' + (K.inCmp(it.id) ? ' is-on' : '') +
            '" data-vs-cmpb="' + esc(it.id) + '">' +
            '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" class="vs-outline">' +
            '<path d="M4 5h6v14H4zM14 5h6v14h-6z"/></svg>' +
            '<span>' + (K.inCmp(it.id) ? 'In the comparison' : 'Compare') + '</span></button>' : '') +
          '<button type="button" class="vs-sidea" data-vs-share>' +
            '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" class="vs-outline">' +
            '<path d="M4 12v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7M16 6l-4-4-4 4M12 2v14"/></svg>' +
            '<span>Send this</span></button>' +
        '</div>' +
        '<p class="vs-showcase">Part of a presentation set, not stock. Venerabull is ' +
          'signing its first manufacturers; real models replace these as lines are signed.</p>' +
        '<div class="vs-note" data-vs-notice hidden>' +
          '<p><b>Not purchasable online yet.</b> This piece is in onboarding. Tell us the room and we confirm ' +
          'the configuration, the freight and the lead time inside one business day &mdash; before anything is charged.</p>' +
          '<p><a href="/pages/customer-support">Customer support</a> &middot; <a href="' +
            esc(sendHref(it, chosen)) + '" data-vs-send>Send the details</a></p>' +
        '</div>' +
      '</div></div>' +

      (it.g && it.g.length
        ? '<section class="vs-band"><figure><img src="' + esc(asset(it.g[0])) + '" alt="' + esc(it.n) +
          ' in place" loading="lazy" width="1400" height="1400"></figure>' +
          '<div class="vs-bandsay"><h2>' + esc(cat.line) + '</h2><p' + BLURB + '>' + esc(it.b) + '</p>' +
          '<p class="vs-bandn">Photographed in the room it is meant for. Four views on this page.</p></div></section>'
        : '') +

      '<section class="vs-detail">' +
        '<div><h2>About this piece</h2><ul class="vs-bul">' +
          String(it.b).split(/\s*\u00b7\s*|,\s+/).filter(function (b) { return b.trim(); })
            .map(function (b) { return '<li' + BLURB + '>' + esc(b.trim()) + '</li>'; }).join('') +
          tbcBullet(it) +
          '<li>Delivery service and level, confirmed with you before any order</li>' +
          '<li>Warranty terms and how registration works, confirmed with you before any order</li>' +
        '</ul></div>' +
        '<div><h2>Specification</h2><dl class="vs-spec">' +
          /* An option's row shows what is chosen, and changes with it; every
             other row is the listing's own figure (506bf70). */
          Object.keys(it.a || {}).filter(function (k) { return it.a[k] !== 'Not applicable'; })
            .map(function (k) {
              var byOpt = (it.o || []).some(function (o) { return o.n === k; });
              return '<dt>' + esc(k) + '</dt><dd' + (byOpt ? ' data-vs-spec="' + esc(k) + '"' : '') + '>' +
                esc(byOpt && cfgA[k] != null ? cfgA[k] : it.a[k]) + '</dd>';
            }).join('') +
          /* A figure no document establishes is said so, in every configuration,
             rather than left out (the catalogue's tbc; 1 Nov 2026). */
          (it.tbc || []).map(function (k) {
            return '<dt>' + esc(k) + '</dt><dd data-vs-tbc>Not confirmed yet</dd>';
          }).join('') +
        '</dl></div>' +
      '</section>' +

      fitBlock(cfg) +

      /* A rail rather than a grid. Six of twenty-nine in a row that can orphan
         at some widths, against all of them in the same height and none of
         them cut off — and a name pinned to two lines so every price in it
         sits on one baseline. */
      '<section class="vs-more"><div class="vs-moreh"><h2>More in ' +
        esc(String(cat.t).toLowerCase()) + '</h2>' +
        '<div class="vs-railn">' +
          '<button type="button" class="vs-arrow" data-vs-rail="-1" aria-label="Back">' +
            svgLine('M15 5 8 12l7 7') + '</button>' +
          '<button type="button" class="vs-arrow" data-vs-rail="1" aria-label="On">' +
            svgLine('m9 5 7 7-7 7') + '</button>' +
        '</div></div>' +
        '<div class="vs-railw"><div class="vs-rail" data-vs-railbox tabindex="0" role="region" ' +
          'aria-label="More in ' + esc(String(cat.t).toLowerCase()) + '">' +
        cat.items.filter(function (x) { return x.id !== it.id; })
          .map(function (x) { return card(x); }).join('') +
        '</div></div><p class="vs-morea"><a class="vs-b2" href="/pages/' + it.cat +
        '?view=all" data-vs-link>Explore all ' + cat.items.length + '</a></p></section>' +

      /* Read three screens down and the price and the way to act on it are
         gone. This brings them back, and only once they have left. */
      '<div class="vs-hold" data-vs-hold hidden><div class="vs-holdin">' +
        '<span class="vs-holdshot"><img src="' + esc(asset(it.img)) + '" alt="" width="80" height="100"></span>' +
        '<span class="vs-holdn"><b>' + esc(it.n) + '</b><em data-vs-holdcfg>' +
          esc(configLine(it, chosen) || cat.t) + '</em></span>' +
        '<span class="vs-holdp" data-vs-holdp>' + money(priceOf(it, deltas, chosen)) + '</span>' +
        '<button type="button" class="vs-b1 vs-holdb" data-vs-top>' +
          (configurable ? 'Configure' : 'Check availability') + '</button>' +
      '</div></div>' +
      '</div>';
    return h;
  }

  /* ---------- search ---------- */

  function norm(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function lev(a, b) {
    var m = a.length, n = b.length, prev = [], cur = [], i, j;
    for (j = 0; j <= n; j++) { prev[j] = j; }
    for (i = 1; i <= m; i++) {
      cur[0] = i;
      for (j = 1; j <= n; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1,
                          prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
      }
      prev = cur.slice();
    }
    return prev[n];
  }
  function near(t, words) {
    /* Typing is wrong more often than it is right. A term is close enough if
       it is within a small edit distance of a whole word OR of that word's
       opening - which is what catches "sana" for "saunas", where the word is
       longer than what was typed. */
    if (t.length < 3) { return false; }
    var bar = t.length > 7 ? 3 : (t.length > 4 ? 2 : 1);
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (!w) { continue; }
      if (Math.abs(w.length - t.length) <= 3 && lev(t, w) <= bar) { return true; }
      if (w.length > t.length &&
          Math.min(lev(t, w.slice(0, t.length)), lev(t, w.slice(0, t.length + 1))) <= bar) { return true; }
    }
    return false;
  }

  function searchPool(q) {
    /* One implementation, in vb-find.js, shared with the prediction row and
       with the bench. This used to be a second copy of the scoring, and a
       second copy is how the page ended up with no aliases, no price words and
       no amp filter while the dropdown had all three. */
    var FD = (typeof VB_FIND !== 'undefined') ? VB_FIND : null;
    if (!FD || !FD.pool) { return []; }
    var CX = (typeof VB_CONTEXT !== 'undefined') ? VB_CONTEXT : null;
    return FD.pool(BYID, BYCAT, q, {
      figures: (CX && CX.known()) ? CX.figures() : null
    });
  }


  /* ---------- paint and route ---------- */

  function show(html) {
    MOUNT.innerHTML = html;
    MOUNT.hidden = false;
    if (PAGE) { PAGE.hidden = true; }
    bind();
  }
  function showPage() {
    MOUNT.hidden = true;
    MOUNT.innerHTML = '';
    if (PAGE) { PAGE.hidden = false; }
  }

  /* ---------- coming back ----------

     Someone works down a shelf of thirty, opens the fourth, decides against
     it and comes back. Landing at the top of the page and losing the filters
     they set is the single most annoying thing a shop can do, and it is
     entirely avoidable: the position and the filters are held for the tab and
     handed back only when they return from a piece in this category. */

  var GRIDK = 'vb.grid.v1:';
  var lastView = null;

  function holdGrid() {
    if (!CAT_MOUNT) { return; }
    try {
      sessionStorage.setItem(GRIDK + CAT_ID, JSON.stringify({ y: window.scrollY || 0, f: FS }));
    } catch (e) { /* private mode */ }
  }
  function heldGrid() {
    try {
      var raw = sessionStorage.getItem(GRIDK + CAT_ID);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  /* ---------- where you landed ----------

     Back, a breadcrumb or Explore all swaps the view in place, so the browser
     says nothing (1 Nov 2026, his audit CP-02: the tab kept the last product's
     title and focus was left on the body). Every view now names itself in the
     title, and when a navigation actually changes the view, focus goes to its
     heading, so a keyboard or screen-reader user hears where they are and
     carries on from there. Not on first load, and not for a filter or a sort,
     which stay in the same view and never come through here. The heading is
     focusable only by script (tabindex -1), so the tab order is unchanged,
     and the scroll position the view chose is kept. */
  var VIEW = null, NAV = 0;
  function landed(key, title, moved) {
    document.title = title;
    var changed = moved && VIEW !== null && key !== VIEW;
    VIEW = key;
    if (!changed) { return; }
    var root = MOUNT.hidden ? PAGE : MOUNT;
    var h = root ? root.querySelector('h1') : null;
    if (!h) { return; }
    if (!h.hasAttribute('tabindex')) { h.setAttribute('tabindex', '-1'); }
    try { h.focus({ preventScroll: true }); } catch (e) { /* an older engine without focus options */ }
  }

  function route(scroll, moved) {
    var q = qs();
    /* Only the latest navigation may draw: a product opened and left with Back
       before the catalogue arrives must not land on top of the category. */
    var mine = ++NAV;
    if (SR_MOUNT) {
      var term = q.q || '';
      document.title = (term ? term + ' — ' : '') + 'Search — Venerabull';
      load().then(function () {
        if (mine !== NAV) { return; }
        show(renderAll(null, term));
        landed('s:' + term, document.title, moved);
        if (scroll) { window.scrollTo(0, 0); }
      });
      return;
    }
    if (q.p) {
      lastView = 'p';
      load().then(function () {
        if (mine !== NAV) { return; }
        var it = BYID[q.p];
        if (!it) { showPage(); landed('page', PAGE_TITLE, moved); return; }
        document.title = it.n + ' — Venerabull';
        show(renderProduct(it));
        landed('p:' + it.id, document.title, moved);
        if (K) { K.saw(it, it.cat, BYCAT[it.cat] ? BYCAT[it.cat].t : ''); }
        if (scroll) { window.scrollTo(0, 0); }
      });
    } else if (q.view === 'all') {
      var held = heldGrid();
      if (held && held.f) { FS = held.f; }
      var back = lastView === 'p' && held && held.y;
      lastView = 'all';
      load().then(function () {
        if (mine !== NAV) { return; }
        show(renderAll(CAT_ID, ''));
        /* the breadcrumb calls this view Everything */
        landed('all', (BYCAT[CAT_ID] ? BYCAT[CAT_ID].t + ' — ' : '') + 'Everything — Venerabull', moved);
        if (back) { window.scrollTo(0, held.y); }
        else if (scroll) { window.scrollTo(0, 0); }
      });
    } else {
      showPage();
      landed('page', PAGE_TITLE, moved);
      if (scroll) { window.scrollTo(0, 0); }
    }
  }

  function go(url) {
    if (qs().view === 'all') { holdGrid(); }
    history.pushState({}, '', url);
    route(true, true);
  }

  function each(sel, fn) { Array.prototype.forEach.call(MOUNT.querySelectorAll(sel), fn); }

  /* A line that says what just happened, then gets out of the way. */
  var sayT = null;
  function say(msg) {
    var el = document.getElementById('vs-say');
    if (!el) {
      el = document.createElement('div');
      el.id = 'vs-say';
      el.className = 'vs-say';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    clearTimeout(sayT);
    sayT = setTimeout(function () {
      el.classList.remove('is-in');
      setTimeout(function () { if (el.parentNode) { el.remove(); } }, 320);
    }, 3200);
  }

  /* The gallery, full screen. Four views of a nine thousand pound piece are
     worth more than a thumbnail rail, and a photograph you cannot look at
     closely is a photograph nobody trusts. */
  var pdItem = null;
  /* The options chosen on the product page in view, so anything that redraws
     its room verdicts (a new room, a new choice) answers for the same
     configuration the price is quoted for (506bf70). */
  var PDC = null;
  function zoom(it, at) {
    if (!it) { return; }
    var shots = [it.img].concat(it.g || []);
    var i = Math.max(0, Math.min(shots.length - 1, at || 0));
    var el = document.createElement('div');
    el.id = 'vs-zoom';
    el.className = 'vs-zoom';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', it.n);
    function draw() {
      el.innerHTML =
        '<button type="button" class="vs-zx" data-z="x" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="19" height="19"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
        (shots.length > 1 ? '<button type="button" class="vs-zn vs-zprev" data-z="p" aria-label="Previous">' +
          '<svg viewBox="0 0 24 24" width="22" height="22"><path d="M15 5 8 12l7 7"/></svg></button>' : '') +
        '<figure class="vs-zfig"><img src="' + esc(asset(shots[i])) + '" alt="' + esc(it.n) + '"></figure>' +
        (shots.length > 1 ? '<button type="button" class="vs-zn vs-znext" data-z="n" aria-label="Next">' +
          '<svg viewBox="0 0 24 24" width="22" height="22"><path d="m9 5 7 7-7 7"/></svg></button>' : '') +
        '<div class="vs-zbar">' + shots.map(function (sname, k) {
          return '<button type="button" class="vs-zt' + (k === i ? ' is-on' : '') + '" data-z="' + k +
            '" aria-label="View ' + (k + 1) + '"><img src="' + esc(asset(sname)) + '" alt=""></button>';
        }).join('') + '</div>';
    }
    draw();
    el.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-z]') : null;
      if (!b) { if (e.target === el) { close(); } return; }
      var w = b.getAttribute('data-z');
      if (w === 'x') { close(); return; }
      if (w === 'p') { i = (i + shots.length - 1) % shots.length; }
      else if (w === 'n') { i = (i + 1) % shots.length; }
      else { i = +w; }
      draw();
    });
    function key(e) {
      if (e.key === 'Escape') { close(); }
      if (e.key === 'ArrowLeft') { i = (i + shots.length - 1) % shots.length; draw(); }
      if (e.key === 'ArrowRight') { i = (i + 1) % shots.length; draw(); }
    }
    function close() {
      document.removeEventListener('keydown', key);
      document.documentElement.classList.remove('vk-locked');
      el.classList.remove('is-in');
      setTimeout(function () { if (el.parentNode) { el.remove(); } }, 240);
    }
    document.addEventListener('keydown', key);
    document.documentElement.classList.add('vk-locked');
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });
  }

  function repaint() {
    var y = window.scrollY;
    /* Every filter tap re-renders the whole page, panel included — so on a
       phone the sheet was torn down and rebuilt closed on every checkbox, and
       you had to reopen it to set a second one. The count updated correctly
       underneath, which is what made it look like a styling problem rather
       than a state one.

       The open state and the sheet's own scroll position are carried across
       the rebuild. The scroll position matters as much as the flag: without it
       you are returned to the top of a list of sixty checkboxes after every
       one you tick. */
    var pOld = MOUNT.querySelector('.vs-panel');
    var wasOpen = !!(pOld && pOld.classList.contains('is-open'));
    var inOld = pOld && pOld.querySelector('.vs-panel-in');
    var panelY = inOld ? inOld.scrollTop : 0;

    show(SR_MOUNT ? renderAll(null, qs().q || '') : renderAll(CAT_ID, ''));
    window.scrollTo(0, y);
    holdGrid();

    if (wasOpen) {
      var pNew = MOUNT.querySelector('.vs-panel');
      var scNew = MOUNT.querySelector('.vs-pscrim');
      if (pNew) {
        /* No transition on the way back: it did not close, so it must not
           look as though it is opening again. */
        pNew.style.transition = 'none';
        pNew.classList.add('is-open');
        if (scNew) { scNew.classList.add('is-open'); }
        document.documentElement.style.overflow = 'hidden';
        var inNew = pNew.querySelector('.vs-panel-in');
        if (inNew) { inNew.scrollTop = panelY; }
        requestAnimationFrame(function () { pNew.style.removeProperty('transition'); });
      }
    }
  }

  function bind() {
    each('a[data-vs-link]', function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) { return; }
        if (href.indexOf('/pages/') !== 0) { return; }
        if (SR_MOUNT) { return; }
        if (href.indexOf('/pages/' + CAT_ID) !== 0) { return; }
        e.preventDefault();
        go(href);
      });
    });
    each('[data-vs-th]', function (b) {
      b.addEventListener('click', function () {
        var st = MOUNT.querySelector('[data-vs-stage]');
        var im = b.querySelector('img');
        if (st && im) { st.src = im.src; }
        each('[data-vs-th]', function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
      });
    });
    var pd = MOUNT.querySelector('[data-vs-pd]');
    pdItem = pd ? BYID[pd.getAttribute('data-vs-pd')] : null;
    if (pd) {
      var it = BYID[pd.getAttribute('data-vs-pd')];
      var deltas = optDeltas(it);
      each('[data-vs-o]', function (r) {
        r.addEventListener('change', function () {
          var total = it.p, picked = [];
          each('[data-vs-o]', function (x) {
            var lab = x.parentNode;
            if (lab && lab.classList) { lab.classList.toggle('is-on', x.checked); }
            if (x.checked) {
              var oi = +x.getAttribute('data-vs-o');
              total += deltas[oi][+x.value];
              picked[oi] = +x.value;
            }
          });
          var p = MOUNT.querySelector('[data-vs-price]');
          if (p) { p.textContent = money(total); }
          var hp = MOUNT.querySelector('[data-vs-holdp]');
          if (hp) { hp.textContent = money(total); }
          var hc = MOUNT.querySelector('[data-vs-holdcfg]');
          if (hc) { hc.textContent = configLine(it, picked); }
          /* the room verdicts, in the buy box and in "In your room", answer
             for what is chosen (506bf70) */
          PDC = picked.slice();
          redrawFit(it);
          /* the facts follow what is chosen (506bf70): the listing's blurb
             shows only on the listing, and the Specification rows the
             options set say the chosen word */
          var bon = blurbOn(it, picked);
          each('[data-vs-blurb]', function (b) { b.hidden = !bon; });
          var cf = chosenAttrs(it, picked);
          each('[data-vs-spec]', function (d) {
            var k = d.getAttribute('data-vs-spec');
            if (cf[k] != null) { d.textContent = cf[k]; }
          });
          /* the link now describes what is on the screen */
          var url = location.pathname + '?p=' + encodeURIComponent(it.id) +
                    (picked.length ? '&c=' + picked.join('-') : '');
          history.replaceState({}, '', url);
          /* and so do both enquiry links */
          each('[data-vs-send]', function (sl) { sl.setAttribute('href', sendHref(it, picked)); });
        });
      });

      /* the holder appears once the real one has gone past */
      var buy = MOUNT.querySelector('.vs-buy');
      var hold = MOUNT.querySelector('[data-vs-hold]');
      if (buy && hold && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) { hold.hidden = en.isIntersecting; });
        }, { rootMargin: '-90px 0px 0px 0px' });
        io.observe(buy);
      }
      var top = MOUNT.querySelector('[data-vs-top]');
      if (top) {
        top.addEventListener('click', function () {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
      var ask = MOUNT.querySelector('[data-vs-ask]');
      var notice = MOUNT.querySelector('[data-vs-notice]');
      if (ask && notice) {
        ask.addEventListener('click', function () { notice.hidden = false; ask.disabled = true; });
      }
    }
    each('input[name="vsprice"]', function (r) {
      r.addEventListener('change', function () { FS.price = r.checked ? r.value : ''; repaint(); });
    });
    each('[data-vs-room]', function (c) {
      c.addEventListener('change', function () { FS.room = c.checked; repaint(); });
    });
    each('input[name="vsrate"]', function (r) {
      r.addEventListener('change', function () { repaint(); });
    });
    each('[data-vs-f]', function (c) {
      c.addEventListener('change', function () {
        var lab = c.getAttribute('data-vs-f');
        var arr = FS.f[lab] || (FS.f[lab] = []);
        var i = arr.indexOf(c.value);
        if (c.checked && i === -1) { arr.push(c.value); }
        if (!c.checked && i > -1) { arr.splice(i, 1); }
        repaint();
      });
    });
    each('[data-vs-drop]', function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-vs-drop'), v = b.getAttribute('data-vs-val');
        if (k === 'price') { FS.price = ''; }
        else if (k === 'room') { FS.room = false; }
        else {
          var lab = k.slice(2), arr = FS.f[lab] || [], i = arr.indexOf(v);
          if (i > -1) { arr.splice(i, 1); }
        }
        repaint();
      });
    });
    each('[data-vs-clear]', function (b) {
      b.addEventListener('click', function () {
        FS = { f: {}, price: '', rate: '', sort: FS.sort, room: false };
        repaint();
      });
    });
    /* ---- the mark, the comparison, the link, the larger view ---- */
    function relabel() {
      each('[data-vs-save]', function (b) {
        var on = K.isSaved(b.getAttribute('data-vs-save'));
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var t = b.querySelector('span');
        if (t) { t.textContent = on ? 'Saved' : 'Save this'; }
      });
      each('[data-vs-cmp]', function (c) {
        var on = K.inCmp(c.getAttribute('data-vs-cmp'));
        c.checked = on;
        if (c.parentNode && c.parentNode.classList) { c.parentNode.classList.toggle('is-on', on); }
      });
      each('[data-vs-cmpb]', function (b) {
        var on = K.inCmp(b.getAttribute('data-vs-cmpb'));
        b.classList.toggle('is-on', on);
        var t = b.querySelector('span');
        if (t) { t.textContent = on ? 'In the comparison' : 'Compare'; }
      });
    }
    if (K) {
      each('[data-vs-save]', function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var it2 = BYID[b.getAttribute('data-vs-save')];
          if (it2) { K.save(it2, it2.cat, BYCAT[it2.cat] ? BYCAT[it2.cat].t : ''); }
          relabel();
        });
      });
      each('[data-vs-cmp]', function (c) {
        c.addEventListener('change', function () {
          var it2 = BYID[c.getAttribute('data-vs-cmp')];
          if (!it2) { return; }
          var r = K.pick(it2, it2.cat, BYCAT[it2.cat] ? BYCAT[it2.cat].t : '');
          if (r === null) { c.checked = false; say('Four at a time is as many as you can read.'); }
          relabel();
        });
      });
      each('[data-vs-cmpb]', function (b) {
        b.addEventListener('click', function () {
          var it2 = BYID[b.getAttribute('data-vs-cmpb')];
          if (!it2) { return; }
          var r = K.pick(it2, it2.cat, BYCAT[it2.cat] ? BYCAT[it2.cat].t : '');
          if (r === null) { say('Four at a time is as many as you can read.'); }
          relabel();
        });
      });
    }

    var sh = MOUNT.querySelector('[data-vs-share]');
    if (sh) {
      sh.addEventListener('click', function () {
        var url = location.href;
        if (navigator.share) { navigator.share({ url: url, title: document.title }).catch(function () {}); return; }
        var ok = false;
        try {
          var ta = document.createElement('textarea');
          ta.value = url; ta.setAttribute('readonly', '');
          ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta); ta.select();
          ok = document.execCommand('copy');
          ta.remove();
        } catch (e) { ok = false; }
        say(ok ? 'Link copied — it opens on this exact configuration.' : url);
      });
    }

    each('[data-vs-zoom]', function (b) {
      b.addEventListener('click', function () { zoom(pdItem, +b.getAttribute('data-vs-zoom')); });
    });

    var rail = MOUNT.querySelector('[data-vs-railbox]');
    if (rail) {
      var wrap = rail.parentNode;
      var edges = function () {
        var max = rail.scrollWidth - rail.clientWidth;
        wrap.classList.toggle('at-start', rail.scrollLeft <= 2);
        wrap.classList.toggle('at-end', rail.scrollLeft >= max - 2);
      };
      rail.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges);
      edges();
      each('[data-vs-rail]', function (b) {
        b.addEventListener('click', function () {
          /* a page is what is on screen, less one card, so the eye keeps its
             place instead of being handed a fresh set of strangers */
          var step = Math.max(200, rail.clientWidth - 210);
          rail.scrollBy({ left: step * (+b.getAttribute('data-vs-rail')), behavior: 'smooth' });
        });
      });
    }

    var so = MOUNT.querySelector('[data-vs-sort]');
    if (so) { so.addEventListener('change', function () { FS.sort = so.value; repaint(); }); }
    var fb = MOUNT.querySelector('[data-vs-fopen]');
    if (fb) { fb.addEventListener('click', function () { openFilters(fb); }); }
    Array.prototype.forEach.call(MOUNT.querySelectorAll('[data-vs-fclose]'), function (b) {
      b.addEventListener('click', closeFilters);
    });
  }

  /* ══════════════════════════════════════════════ the filter sheet, on a phone ══
     It used to be display:block — the panel expanded inline and pushed the grid
     down by 1,415px, measured. You tapped Filter, the page grew by more than a
     screen and a half, you set a checkbox, and then you scrolled back down to
     find out what it had done. Nothing was ever visible at the same time as the
     thing it was filtering.

     It is a sheet now: over the page, scrolling on its own, with the result
     count in the foot as the button that closes it. The desktop layout is
     untouched — all of the geometry lives in vb-mobile.css inside a media
     query, and this JS only does the parts CSS cannot: the scroll lock, the
     key handling, and putting focus somewhere sensible. */
  var FOPENER = null;

  function openFilters(btn) {
    var p = MOUNT.querySelector('.vs-panel');
    if (!p) { return; }
    FOPENER = btn || null;
    p.classList.add('is-open');
    var sc = MOUNT.querySelector('.vs-pscrim');
    if (sc) { sc.classList.add('is-open'); }
    document.documentElement.style.overflow = 'hidden';
    var c = p.querySelector('.vs-pclose');
    if (c) { setTimeout(function () { try { c.focus(); } catch (e) {} }, 60); }
  }

  function closeFilters() {
    var p = MOUNT.querySelector('.vs-panel');
    if (!p || !p.classList.contains('is-open')) { return; }
    p.classList.remove('is-open');
    var sc = MOUNT.querySelector('.vs-pscrim');
    if (sc) { sc.classList.remove('is-open'); }
    document.documentElement.style.removeProperty('overflow');
    if (FOPENER && FOPENER.focus) { try { FOPENER.focus(); } catch (e) {} }
    FOPENER = null;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeFilters(); }
  });

  /* Setting your room mid-page re-answers the question you were reading. */
  document.addEventListener('vb:room', function () {
    if (qs().view === 'all' || SR_MOUNT) { repaint(); return; }
    var pd = MOUNT.querySelector('[data-vs-pd]');
    if (!pd) { return; }
    var it = BYID[pd.getAttribute('data-vs-pd')];
    /* both answers, for the configuration in view (506bf70) */
    if (it) { redrawFit(it); }
  });

  window.addEventListener('pagehide', function () { if (qs().view === 'all') { holdGrid(); } });
  window.addEventListener('popstate', function () { route(false, true); });

  /* links on the server-rendered category page above the mount */
  document.addEventListener('click', function (e) {
    /* A link inside the view has already navigated by the time the click
       bubbles here, and the redraw has taken it out of the mount, so
       MOUNT.contains() no longer recognises it (his real-browser check of
       da87083: a second identical history entry, and focus lost to the page).
       A click someone already handled is not handled twice. */
    if (e.defaultPrevented) { return; }
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a || MOUNT.contains(a) || !CAT_ID) { return; }
    var href = a.getAttribute('href') || '';
    if (href.indexOf('/pages/' + CAT_ID + '?') !== 0) { return; }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) { return; }
    e.preventDefault();
    go(href);
  });

  /* fitRows is exported so the compare table in vb-keep-ui.js can answer the
     same question the same way. That file loads on every page and this one does
     not, so it asks for VBShop rather than assuming it, and draws no verdict
     rows at all when it is absent. One engine, two surfaces, one answer. */
  window.VBShop = { load: load, byId: BYID, byCat: BYCAT, card: card, money: money,
                    asset: asset, norm: norm, lev: lev, fitRows: fitRows };

  route(false);
})();
